module.exports = __webpack_public_path__ + "fonts/1e9892c0-6927-4412-9874-1b82801ba47a.a17c827.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/1e9892c0-6927-4412-9874-1b82801ba47a.woff
// module id = 156
// module chunks = 245 246